<div class="featured-in">
  <div><h2>Featured In</h2></div>
  <div class="container">
    <div class="featured-images">
      <ngx-glide [showArrows]="true" [showBullets]="false" type="carousel" [breakpoints]="breakpoints" [perView]="6" [bound]="false" arrowLeftLabel="" arrowRightLabel="">
        <span *ngFor="let item of featuredInJson?.slide1" [className] = "item.divClass">
          <a [target]="item.target" [href]="item.url" rel="nofollow">
            <div class="{{item.imgClass}} sprite-bg" data-bg="assets/images/homepage/featuredImg/Featured_v1.png?w=auto"></div>
          </a>
        </span>
      </ngx-glide>
    </div>
  </div>
  <div class="chat-wrapper">
    <app-chat-with-us [html]="'Have a question? Check out our <a href=/support/faqs.php target=_blank>FAQs</a> page or chat with us on Facebook or WhatsApp.'" fbposition="15" whatsposition="16" pageName='homepage'></app-chat-with-us>
  </div>
</div>
